import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import OrderHistory from "../../../components/Custom/Sales/Order/OrderHistory";

const OrderList = () => {

    const { t } = useTranslation();
    return (
        <>
            <PageTitle activeMenu={t('sales')} motherMenu={t('sales')} />

            <Row>
                <Col className="col-md-12">
                    <OrderHistory/>
                </Col>
            </Row>
        </>
    );
}

export default OrderList;